import { render, staticRenderFns } from "./GUserInfo.vue?vue&type=template&id=3946befc&scoped=true&"
import script from "./GUserInfo.vue?vue&type=script&lang=ts&"
export * from "./GUserInfo.vue?vue&type=script&lang=ts&"
import style0 from "./GUserInfo.vue?vue&type=style&index=0&id=3946befc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3946befc",
  null
  
)

export default component.exports